//////////////////
// IMPORTS
//////////////////
// schema
// import * as ISchema from '@schema';
// libraries
import * as React from "react";
import Radium from "radium";
import { connect } from "react-redux";
import { createFragmentContainer } from "react-relay";
// travel-time-goal imports
import IGoalsWrapper from "./goals-wrapper.d";
import { BaseGoalComponent } from "./base-goal.component";
import * as styles from "./goals-wrapper.styles";
import { WorkAddress } from "@components/work-address";
// other internals
import { logger } from "@util/logger.util";
import { removeGoal, upsertTravelTime } from "@mutations";
import { standardGoals } from "@util/goal.util";
import { snackBarOpen } from "@actions/snack-bar.actions";
import { track, TrackingEvents } from "@util/analytics.util";
import { Switch } from "@clockwise/design-system";
// material-ui
import withStyles from "@material-ui/core/styles/withStyles";

//////////////////
// COMPONENT
//////////////////
@Radium
export class TravelTimeGoalComponent extends BaseGoalComponent<IGoalsWrapper.ITravelTime.State> {
  constructor(props: IGoalsWrapper.Props) {
    super(props, standardGoals.TravelTime);
    const goal = this.findGoal();
    const address =
      (this.props.org.workAddressForUser.__typename !== "GraphEntityError" &&
        this.props.org.workAddressForUser.rawAddress) ||
      null;
    this.state = {
      address,
      showAddressSearch: false,
      selected: !!goal,
      loading: false,
      query: "",
    };
  }

  // Handlers
  private onMutateOnToggleSuccess = (isInputChecked: boolean) => {
    this.setState({ loading: false });
    this.props.snackBarOpen(`${isInputChecked ? "Added" : "Removed"} "Travel Time" preference`);
  };

  protected mutateOnToggle(isInputChecked: boolean): void {
    const org = this.props.org;

    track(TrackingEvents.SETTINGS.UPDATE_TRAVEL_TIME, { isInputChecked });

    if (isInputChecked) {
      this.setState({ loading: true });
      upsertTravelTime(
        this.props.relay.environment,
        { orgId: org.id, options: {} },
        this.onMutateOnToggleSuccess.bind(this, isInputChecked),
        this.onMutationFailure,
      );
    } else {
      const goal = this.findGoalInput();
      if (goal) {
        this.setState({ loading: true });
        removeGoal(
          this.props.relay.environment,
          { goal, orgId: org.id },
          this.onMutateOnToggleSuccess.bind(this, isInputChecked),
          this.onMutationFailure,
        );
      } else {
        logger.debug("Couldn't find goal to remove");
      }
    }
  }

  private onMutationFailure = (): void => {
    this.setState({ loading: false });
    this.props.snackBarOpen("An error occurred!");
  };

  public render(): JSX.Element {
    const { org } = this.props;

    return (
      <div style={styles.goal}>
        <Switch
          checked={this.state.selected}
          onChange={(checked) => this.onToggle(null, checked)}
          disabled={this.state.loading}
          label="Preserve time for travel around events with an external location"
        />
        {this.props.isWebSettings ? <div className="cw-mb-16" /> : ""}
        <div style={!this.state.selected ? { cursor: "not-allowed" } : undefined}>
          <div
            style={
              this.state.selected ? styles.subSettingContainer : styles.subSettingDisabledContainer
            }
          >
            <WorkAddress org={org} isWebSettings={this.props.isWebSettings} />
          </div>
        </div>
      </div>
    );
  }
}

//////////////////
// WITH STYLES
//////////////////
export const TravelTimeGoalStyled = withStyles(styles.classes)(TravelTimeGoalComponent);

//////////////////
// REDUX
//////////////////
function mapStateToProps(_state: any, _ownProps: IGoalsWrapper.Container) {
  return {}; // add redux state here, if needed
}

const reduxContainer = connect(mapStateToProps, {
  snackBarOpen,
})(TravelTimeGoalStyled);

//////////////////
// RELAY
//////////////////
import { fragments } from "./TravelTimeGoal.gql";
export const TravelTimeGoal = createFragmentContainer(reduxContainer, fragments);
